import { createUseStyles } from "react-jss";
import { ITheme } from "../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    background: theme.colors.Background1,
    color: theme.colors.TextDefault,
    overflow: "scroll",
  },
  banner: {
    display: "flex",
    gap: theme.spacing.space12,
    background: theme.colors.Background4,
    borderRadius: theme.radius.small,
    padding: theme.spacing.space12,
    alignItems: "center",
  },
  content: {
    padding: `${theme.spacing.space8}px ${theme.spacing.space16}px ${theme.spacing.space48}px `,
    marginTop: 70,
    display: "grid",
    gap: theme.spacing.space32,
  },
  menuItem: {
    display: "grid",
    gap: theme.spacing.space24,
  },
  icon: {
    fontSize: 18,
  },
  item: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space12,
  },
  title: {
    width: "100%",
  },
  buttonGroup: {
    display: "grid",
    gap: theme.spacing.space12,
  },
  userId: {
    display: "flex",
    gap: theme.spacing.space8,
  },
}));
